// extracted by mini-css-extract-plugin
export default {"flag":"DetailsPage_flag__dbAqy","container":"DetailsPage_container__Zk9XP","details":"DetailsPage_details__f543p","link":"DetailsPage_link__Lsz8j"};